import { render } from "./menusView.vue?vue&type=template&id=7519f348&scoped=true"
import script from "./menusView.vue?vue&type=script&lang=js"
export * from "./menusView.vue?vue&type=script&lang=js"

import "./menusView.vue?vue&type=style&index=0&id=7519f348&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7519f348"]])

export default __exports__